import { Button } from 'antd';
import { PhoneOutlined, StopOutlined, LoadingOutlined } from '@ant-design/icons';
import { useTestCall } from './Video/PatientTestCallManager';

export const AutomatedClinicianLauncher = () => {
  const { isTestCallEnabled, setIsTestCallEnabled, connectionState, stopSession } = useTestCall();

  const handleClick = () => {
    if (!isTestCallEnabled) {
      setIsTestCallEnabled(true);
    } else if (connectionState === 'active') {
      stopSession();
      setIsTestCallEnabled(false);
    }
  };

  const getButtonProps = () => {
    if (!isTestCallEnabled) {
      return { children: 'Test Call', icon: <PhoneOutlined />, loading: false, danger: false };
    }

    switch (connectionState) {
      case 'idle':
      case 'connecting':
        return { children: 'Connecting...', icon: <LoadingOutlined />, loading: true, danger: false };
      case 'ready':
        return { children: 'Starting...', icon: <LoadingOutlined />, loading: true, danger: false };
      case 'active':
        return { children: 'End Test Call', icon: <StopOutlined />, loading: false, danger: true };
      case 'error':
        return { children: 'Error', icon: <PhoneOutlined />, loading: false, danger: true };
    }
  };

  const buttonProps = getButtonProps();

  return (
    <Button
      type="primary"
      size="small"
      onClick={handleClick}
      disabled={connectionState === 'connecting' || connectionState === 'ready'}
      {...buttonProps}
      data-testid="automated-clinician-launcher"
    />
  );
};
